import {chainWalk, deepCopyObject} from "../../../util/Util";

export const updateConfigurationsInAdtaAssetObject = (asset, configurations, alias) => {
    const updatedAsset = deepCopyObject(asset);
    updatedAsset.assetDetails.alias = chainWalk(() => alias.toString(), "");
    updatedAsset.assetDetails.assetAttributes.sorterConfig =
        chainWalk(() => JSON.stringify(configurations.sorterConfig), "[]")
    updatedAsset.assetDetails.assetAttributes.sorterTestPackage =
        chainWalk(() => JSON.stringify(configurations.sorterTestPackage), "[]")
    return updatedAsset;
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtadevice/datamodel/AdtaAssetModelResource.js